import { render, staticRenderFns } from "./RecycleModal.vue?vue&type=template&id=009d887e&scoped=true"
import script from "./RecycleModal.vue?vue&type=script&lang=js"
export * from "./RecycleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009d887e",
  null
  
)

export default component.exports